<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="ack"></a>ACKNOWLEDGMENTS</h1>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="center"><img alt="Image" src="images/dw.jpg"/></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="text"><a id="page_xi"></a>I want to express my gratitude to S. T. Joshi, the foremost Lovecraft scholar in the world, for his endorsement and for taking time away from his own creative labors to read the manuscript of a relatively unknown writer such as myself and then provide substantial feedback that ended up enriching the book as a whole. In my day, we had a phrase: a gentleman and a scholar. If any person deserves to be described in such a fashion, that person is S.T. Joshi.</p>
<p class="textindent">I also want to acknowledge and thank my two editors at Red Wheel/Weiser, Kim Ehart and Amber Guetebier, along with Rachel Leach, Eryn Carter, and Sylvia Hopkins, among others. Although I am the author of this book, there wouldn't really be a “book” at all if it weren't for these individuals and for the work of all of the other fine professionals at Red Wheel/Weiser.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_acknowledgments.vue?2222c49c